// extracted by mini-css-extract-plugin
export default {"root":"IconReviewStar_root__0GzPu","filled":"IconReviewStar_filled__2IWCg"};